module.exports = __webpack_public_path__ + "https://gloprocessor.com/ment/img/visa.57f4b500.png";